/* @flow */
import * as React from 'react';

type TabContentProps = { name: string, active?: boolean, children: React.Node };
const TabContent = ({ name, active = false, children }: TabContentProps) => (
  <div
    className={`tab-pane fill fade ${active ? 'show active' : ''}`}
    style={{ overflow: 'hidden' }}
    id={name}
    role="tabpanel"
    aria-labelledby={`${name}-tab`}
  >
    {children}
  </div>
);

export default TabContent;
